import { createRoutine } from 'redux-saga-routines';

export * from './ROItem/routines';
export * from './ROPicklist/routines';
export * from './reports/routines';

export const createReservation = createRoutine('CREATE_RESERVATION');

export const updateReservation = createRoutine('UPDATE_RESERVATION');

export const unlinkReservation = createRoutine('UNLINK_RESERVATION');

export const createReservationOrders = createRoutine(
  'CREATE_RESERVATION_ORDERS'
);

export const updateReservationOrders = createRoutine(
  'UPDATE_RESERVATION_ORDERS'
);

export const fetchReservationForEdit = createRoutine('FETCH_RESERVATION_EDIT');

export const fetchReservationForView = createRoutine('FETCH_RESERVATION_VIEW');

export const fetchReservationPicklists = createRoutine(
  'FETCH_RESERVATION_PICKLISTS'
);

export const fetchInventoryItemAvailabilityByLocation = createRoutine(
  'FETCH_INVENTORY_ITEM_AVAILABILITY_BY_LOCATION'
);

export const fetchInventoryPackageAvailabilityByLocation = createRoutine(
  'FETCH_INVENTORY_PACKAGE_AVAILABILITY_BY_LOCATION'
);

export const fetchReservationToday = createRoutine('FETCH_RESERVATION_TODAY');

export const fetchReservationUpcoming = createRoutine(
  'FETCH_RESERVATION_UPCOMING'
);

export const fetchReservationPending = createRoutine(
  'FETCH_RESERVATION_PENDING'
);

export const fetchReservationUpcomingEvents = createRoutine(
  'FETCH_RESERVATION_UPCOMING_EVENTS'
);

export const fetchReservationAvailableEvent = createRoutine(
  'FETCH_RESERVATION_AVAILABLE_EVENT'
);

export const fetchReservationAvailableEvents = createRoutine(
  'FETCH_RESERVATION_AVAILABLE_EVENTS'
);

export const fetchReservationsOrderItems = createRoutine(
  'FETCH_RESERVATIONS_ORDER_ITEMS'
);

export const updateReservationStatus = createRoutine(
  'UPDATE_RESERVATION_STATUS'
);

export const fetchReservationTrackingMethodOptions = createRoutine(
  'FETCH_RESERVATION_TRACKING_METHOD_OPTIONS'
);

export const fetchROItemOptions = createRoutine('FETCH_RO_ITEM_OPTIONS');

export const fetchReservationArchived = createRoutine(
  'FETCH_RESERVATION_ARCHIVED'
);

export const fetchReservationExportUrl = createRoutine(
  'FETCH_RESERVATION_EXPORT_URL'
);
